import React from 'react';

const timelineData = [
  {
    year: '1989',
    title: 'A kezdetek',
    text: 'Vállalkozásunkat használt bútor és háztartási felszerelések kereskedelmével kezdtük egy 500 m² bérelt üzletben.',
    image: null,
  },
  {
    year: '1990-es évek',
    title: 'Folyamatos bővülés',
    text: 'Átváltottunk új bútor, szőnyeg, függöny, háztartási és konyhai berendezések forgalmazására.',
    image: null,
  },
  {
    year: '2007',
    title: 'Saját üzlet',
    text: 'Megépítettük az új üzletünket 500 m² alapterülettel, amelyet folyamatosan bővítettünk.',
    image: null,
  },
  {
    year: '2010-es évek',
    title: 'Bővítés 1500 m²-re',
    text: 'Az üzlet teljes alapterületét 1500 m²-re növeltük, szélesebb választékkal.',
    image: null,
  },
  {
    year: '2018',
    title: 'Asztalos műhely',
    text: 'Elkészült modern műhelyünk lapszabászattal – ettől kezdve minden egyedi bútor itt készül.',
    image: null,
  },
  {
    year: 'Ma',
    title: 'Komplett szolgáltatás',
    text: '3D tervezés, gyártás, szállítás – minden egy helyen, teljes körű megoldás.',
    image: null,
  },
];

export default function Timeline() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="mx-auto max-w-[var(--container-max)] px-4">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="text-sm font-semibold text-[var(--color-accent)] uppercase tracking-wider mb-3">
            Történetünk
          </div>
          <h2 className="text-3xl md:text-4xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] tracking-tight">
            Több mint 35 év folyamatos fejlődés
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-[var(--color-border)] md:-translate-x-1/2" />

          {/* Timeline Items */}
          <div className="space-y-12">
            {timelineData.map((item, index) => (
              <div
                key={index}
                className={`relative flex items-start ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                } gap-8`}
              >
                {/* Content */}
                <div className={`flex-1 pl-20 md:pl-0 ${index % 2 === 0 ? 'md:pr-8 md:text-right' : 'md:pl-8 md:text-left'}`}>
                  {/* Year Badge */}
                  <div className="inline-block px-5 py-2 bg-[var(--color-accent)] text-white text-sm md:text-base font-semibold rounded-full mb-4 shadow-sm">
                    {item.year}
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-semibold text-[var(--color-text-primary)] mb-3 leading-tight">
                    {item.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-[var(--color-text-secondary)] leading-relaxed text-base">
                    {item.text}
                  </p>
                </div>

                {/* Center Dot */}
                <div className="absolute left-8 top-2 md:left-1/2 md:-translate-x-1/2 w-5 h-5 md:w-4 md:h-4 bg-[var(--color-accent)] rounded-full border-4 border-white shadow-md" />

                {/* Optional Thumbnail Space (Desktop only) */}
                <div className="flex-1 hidden md:block" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

